<div class="popup-global-layout width-650 p-4 p-md-5">
    <div class="d-flex justify-content-end"><mat-icon class="icon" (click)="onDecline()">close</mat-icon></div>
    <div class="global-title">Are you sure to delete?</div>
    <div class="global-yellow-bar"></div>
    <div class="global-text">If you delete cash transfer account, it will be permanently deleted.</div>
    <div class="global-button-format">
      <button (click)="onDecline()" class="dw-secondary-button icon-right">No, keep it<mat-icon class="blue">keyboard_arrow_right</mat-icon></button>
      <button (click)="onAccept()" class="dw-primary-button icon-right">Yes, delete it<mat-icon class="black">keyboard_arrow_right</mat-icon></button>
    </div>
  </div>